import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import union_img from "../../../../assets/baseVersion/Union.svg"

interface SubscriptionMessageProps {
  open: boolean;
  onClose: () => void;
  data?: {
    title?: string;
    content?: string;
    data?: any;
    buttons?: {
      label?: string;
      class?: string;
      callBack?: () => void;
    }[];
  };
}

const SubscriptionMessage: React.FC<SubscriptionMessageProps> = ({ open, onClose, data }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          textAlign: "center",
          padding: "20px",
        },
      }}
    >
      {/* Close Button */}
      <Box
        sx={{
          position: "absolute",
          top: "10px",
          right: "10px",
          cursor: "pointer",
        }}
        onClick={onClose}
      >
        <CloseIcon sx={{ color: "#999", fontSize: "20px" }} />
      </Box>

      {/* Crown Icon */}
      <Box sx={{ textAlign: "center", my: 1}}>
        <img src={union_img} alt="Crown Icon" style={{ width: "80px" }} />
      </Box>

      <DialogTitle
        sx={{
          color: "#000",
          fontWeight: 900,
          fontSize: "18px",
        }}
      >
        {data?.title}
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body2"
          sx={{
            color: "#555",
            fontSize: "14px",
            fontWeight:400,
            mb: 1,
          }}
        >
          {data?.content}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
  {data?.buttons?.map((btn, index) => (
    <Button
      key={index}
      onClick={() => {
        if (btn.callBack) btn.callBack();
        onClose();
      }}
      // sx={{
      //   borderRadius: "8px",
      //   padding: "8px 16px",
      //   fontSize: "14px",
      //   fontWeight: "bold",
      //   textTransform: "none",
      //   ...(btn.label === "Upgrade!"
      //     ? {
      //         backgroundColor: "#5A3FFF",
      //         color: "#FFF",
      //         "&:hover": { backgroundColor: "#482FCC" },
      //       }
      //     : {
      //         border: "1px solid #5A3FFF",
      //         color: "#5A3FFF",
      //         backgroundColor: "transparent",
      //         "&:hover": { backgroundColor: "#EFEFFF" },
      //       }),
      // }}
      sx={{width:150}}
      variant={btn.label === "Upgrade!" ? "contained" : btn.label === "Cancel" ? "outlined" : "contained"}
    >
      {btn.label}
    </Button>
  ))}
</DialogActions>

    </Dialog>
  );
};

export default SubscriptionMessage;
